import React from 'react';
import { connect } from 'react-redux';
import querystring from 'querystring';

import NavSearch from './NavSearch';
import * as util from './util';

import { closeComponent } from 'actions';

import GlobalNavStore from 'stores/GlobalNavStore';
import AccountStore from 'stores/AccountStore';

class MainX extends React.Component {
    render() {
        const { closeComponent, children } = this.props;
        return (
            <div className="cc-main" onClick={closeComponent}>
                {children}
                <MainFooter />
            </div>
        );
    }
}

export const Main = connect(null, {
    closeComponent
})(MainX);

class MainHeaderX extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scrolled: false
        };
        this._onScroll = this._onScroll.bind(this);
    }

    componentDidMount() {
        if (window) {
            window.addEventListener('scroll', this._onScroll);
        }
    }

    componentWillUnmount() {
        if (window) {
            window.removeEventListener('scroll', this._onScroll);
        }
    }

    _onScroll(event) {
        if (document) {
            const banner = this.refs.banner;
            const bannerRect = banner.getBoundingClientRect();
            if (this.state.scrolled) {
                if (bannerRect.bottom > 0) {
                    this.setState({ scrolled: false });
                }
            } else if (bannerRect.bottom < 0) {
                this.setState({ scrolled: true });
            }
        }
    }

    render() {
        const { club, user } = this.props;
        const navLeftItems = GlobalNavStore.getGlobalNav();
        const navRightItems = [AccountStore.getAccountNav(user)];
        return (
            <div className="cc-header">
                <div className="cc-banner">
                    <div ref="banner" className="cc-banner-logo" />
                    <div className="cc-banner-image" />
                </div>
                <div className={`cc-navbar${this.state.scrolled ? ' cc-scrolled' : ''}`}>
                    <div className="cc-navbar-brand">
                        <div className="cc-navbar-brand-logo" />
                        <h1>{club.title}</h1>
                    </div>
                    <NavBarItems menuButton="menu" left items={navLeftItems} />
                    <NavBarItems menuButton="menu" right items={navRightItems}>
                        <NavSearch />
                    </NavBarItems>
                </div>
            </div>
        );
    }
}

export const MainHeader = connect(state => ({
    club: state.club,
    user: state.user
}))(MainHeaderX);

class NavBarItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
        this._onMenuButtonClick = this._onMenuButtonClick.bind(this);
        this._onShieldClick = this._onShieldClick.bind(this);
    }

    hideDelay(func) {
        if (this.showDelayTimer) {
            clearTimeout(this.showDelayTimer);
            this.showDelayTimer = undefined;
        }
        this.showWaitFunc = undefined;
        if (this.hideDelayTimer) {
            return;
        }
        this.hideDelayTimer = setTimeout(() => {
            func();
            this.hideDelayTimer = undefined;
            if (this.showWaitFunc) {
                this.showWaitFunc();
                this.showWaitFunc = undefined;
            }
        }, 200);
    }

    showWait(func) {
        if (this.showDelayTimer) {
            clearTimeout(this.showDelayTimer);
            this.showDelayTimer = undefined;
        }
        if (this.hideDelayTimer) {
            this.showWaitFunc = func;
        } else {
            this.showDelayTimer = setTimeout(func, 100);
        }
    }

    _onMenuButtonClick(event) {
        this.setState({ visible: true });
    }

    _onShieldClick(event) {
        this.setState({ visible: false });
    }

    render() {
        const { items } = this.props;
        let className = 'cc-navbar-left';
        if (this.props.right) {
            className = 'cc-navbar-right';
        }
        let menuButton;
        if (this.props.menuButton) {
            menuButton = (
                <i className="cc-navbar-menu-button material-icons" onClick={this._onMenuButtonClick}>
                    {this.props.menuButton}
                </i>
            );
        }
        let itemsClassName = 'cc-navbar-items';
        let shield;
        if (this.state.visible) {
            itemsClassName += ' cc-navbar-visible';
            shield = <div className="cc-navbar-menu-shield" onClick={this._onShieldClick} />;
        }
        const controller = this;
        return (
            <div className={className}>
                {menuButton}
                <div className={itemsClassName}>
                    <div className="cc-navbar-items-header" />
                    <div className="cc-navbar-items-body">
                        <ul>
                            {items.map((item, index) => <NavBarItem key={index} item={item} controller={controller} />)}
                            {this.props.children}
                        </ul>
                    </div>
                </div>
                {shield}
            </div>
        );
    }
}

const NavBarItem = ({ item, controller }) => {
    switch (item.type) {
        case 'link':
            return <NavBarItemLink item={item} controller={controller} />;
        case 'dropbar':
            return <NavBarItemDropBar item={item} controller={controller} />;
    }
};

const addGlobalParams = (href, params) => {
    const globalParams = {};
    if (params.team !== undefined) {
        globalParams.team = params.team;
    }
    if (params.type !== undefined) {
        globalParams.type = params.type;
    }
    if (params.season !== undefined) {
        globalParams.season = params.season;
    }
    const qs = querystring.stringify(globalParams);
    if (qs) {
        href = `${href}?${qs}`;
    }
    return href;
};

class NavBarItemLinkX extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false
        };
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
    }

    _onMouseEnter(event) {
        if (util.isTouchDevice()) {
            return;
        }
        this.props.controller.showWait(() => {
            this.setState({ hover: true });
        });
    }

    _onMouseLeave(event) {
        if (util.isTouchDevice()) {
            return;
        }
        this.props.controller.hideDelay(() => {
            this.setState({ hover: false });
        });
    }

    render() {
        const { item, params } = this.props;
        let href = item.href;
        if (item.takesParams) {
            href = addGlobalParams(href, params);
        }
        return (
            <li onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}>
                <div className={`${this.state.hover ? 'cc-navbar-item-hover ' : ''}cc-navbar-item`}>
                    <i className="cc-navbar-item-icon material-icons">{item.icon}</i>
                    <a className="cc-navbar-item-text" href={href}>
                        {item.value}
                    </a>
                </div>
            </li>
        );
    }
}

const NavBarItemLink = connect(state => ({
    params: state.params
}))(NavBarItemLinkX);

class NavBarItemDropBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        this._onClick = this._onClick.bind(this);
        this._open = this._open.bind(this);
        this._close = this._close.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._fakeOnClick = this._fakeOnClick.bind(this);
    }

    _onClick(event) {
        if (this.state.open) {
            this._close();
        } else {
            this._open();
        }
    }

    _open() {
        this.props.controller.showWait(() => {
            this.refs.dropBar.show();
            this.setState({ open: true });
        });
    }

    _close() {
        this.props.controller.hideDelay(() => {
            this.refs.dropBar.hide();
            this.setState({ open: false });
        });
    }

    _onMouseEnter(event) {
        if (util.isTouchDevice()) {
            return;
        }
        this._open();
    }

    _onMouseLeave(event) {
        this._close();
    }

    _fakeOnClick() {}

    render() {
        const { item } = this.props;
        return (
            <li onClick={this._fakeOnClick} onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}>
                <div className={`${this.state.open ? 'cc-navbar-item-hover ' : ''}cc-navbar-item`} onClick={this._onClick}>
                    <i className="cc-navbar-item-icon material-icons">{item.icon}</i>
                    <span className="cc-navbar-item-text">{item.value}</span>
                    <i className="cc-navbar-item-icon material-icons">{this.state.open ? 'arrow_drop_up' : 'arrow_drop_down'}</i>
                </div>
                <DropBar ref="dropBar" data={item.dropBar} />
            </li>
        );
    }
}

/* ****************************************************************************
  Drop Bar Navigation (Main Sub Menus)
******************************************************************************/

class DropBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visable: false
        };
    }

    show() {
        this.setState({ visable: true });
    }

    hide() {
        this.setState({ visable: false });
    }

    render() {
        const { data } = this.props;
        return (
            <div className={`${this.state.visable ? 'cc-dropbar-slidedown ' : ''}cc-dropbar`}>
                <div className="cc-dropbar-box">{data.map((menu, index) => <DropBarMenu key={index} menu={menu} />)}</div>
            </div>
        );
    }
}

const DropBarMenu = ({ menu }) => {
    let heading;
    if (menu.heading) {
        heading = (
            <li>
                <span className="cc-dropbar-heading cc-navbar-item-text">{menu.heading}</span>
            </li>
        );
    }
    return (
        <ul>
            {heading}
            {menu.items.map((item, index) => <DropBarMenuItem key={index} item={item} />)}
        </ul>
    );
};

let DropBarMenuItem = ({ item, params }) => {
    let href = item.href;
    if (item.takesParams) {
        href = addGlobalParams(href, params);
    }
    return (
        <li>
            <a className="cc-navbar-item-text" href={href}>
                {item.value}
            </a>
        </li>
    );
};

DropBarMenuItem = connect(state => ({
    params: state.params
}))(DropBarMenuItem);

/* ****************************************************************************
  Footer
******************************************************************************/

export const Body = ({ id, children }) => (
    <div id={id} className="cc-body">
        {children}
    </div>
);

/* ****************************************************************************
  Footer
******************************************************************************/

const MainFooter = () => (
    <div className="cc-footer">
        <div className="cc-footer-body">
            <div className="cc-footer-block">
                <p>
                    <strong>About Chorleywood CC</strong>
                </p>
                <a href="/about">About</a>
                <a href="/location">Location</a>
                <a href="/contact">Contact Us</a>
                <a href="/50-club">50 Club</a>
                <a href="http://colts.cwcricket.org" target="_new">
                    Colts
                </a>
            </div>
            <div className="cc-footer-block">
                <p>
                    <strong>External Information</strong>
                </p>
                <a href="http://www.hertscricket.org/" target="_blank">
                    Hertfordshire Cricket
                </a>
                <a href="http://www.hertsleague.co.uk/" target="_blank">
                    Saracens Hertfordshire Cricket League
                </a>
                <a href="http://chessvalley.play-cricket.com/" target="_blank">
                    Lords Chess Valley Sunday League
                </a>
                <a href="http://www.ecb.co.uk/" target="_blank">
                    England and Wales Cricket Board
                </a>
                <a href="http://www.ecb.co.uk/development/club-cricket/clubmark/" target="_blank">
                    ECB Clubmark
                </a>
            </div>
            <div className="cc-footer-block">
                <p>
                    <strong>Follow Us</strong>
                </p>
                <a href="//www.twitter.com/chorleywoodcc" target="_blank">
                    <span className="socicon-twitter" /> Twitter
                </a>
                <a href="//www.facebook.com/chorleywoodcc" target="_blank">
                    <span className="socicon-facebook" /> Facebook
                </a>
                <a href="//www.instagram.com/chorleywoodcc" target="_blank">
                    <span className="socicon-instagram" /> Instagram
                </a>
            </div>
            <div className="cc-footer-copyright">Copyright &copy; 1999-2025 Martin Tyler</div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Main.jsx